import { PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { unityDarkTokens, unityLightTokens } from '../unityTokens';
import { green, white } from './colors';
import { border } from './border';

export const input = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['input'] => {
  if (opts.panwRebrandStubYear) {
    return mode === 'light'
      ? {
          backgroundColor: unityLightTokens['--input-solid-bg'],
          hoverBackgroundColor: unityLightTokens['--input-solid-bg-hover'],
          disabledBackgroundColor: unityLightTokens['--input-solid-bg-disabled'],
          borderColor: 'transparent',
          focusBorderColor: 'transparent',
          hoverBorderColor: 'transparent',
          placeholderColor: unityLightTokens['--text-placeholder-color'],
          labelColor: unityLightTokens['--text-placeholder-color'],
          errorColor: unityLightTokens['--input-text-destructive'],
          selected: unityLightTokens['--bg-color-surface-selected'],
        }
      : {
          backgroundColor: unityDarkTokens['--input-solid-bg'],
          hoverBackgroundColor: unityDarkTokens['--input-solid-bg-hover'],
          disabledBackgroundColor: unityDarkTokens['--input-solid-bg-disabled'],
          borderColor: 'transparent',
          focusBorderColor: 'transparent',
          hoverBorderColor: 'transparent',
          placeholderColor: unityDarkTokens['--text-placeholder-color'],
          labelColor: unityDarkTokens['--text-placeholder-color'],
          errorColor: unityDarkTokens['--input-text-destructive'],
          selected: unityDarkTokens['--bg-color-surface-selected'],
        };
  }

  const borderPalette = border(mode, opts)!;
  return mode === 'light'
    ? {
        backgroundColor: white,
        borderColor: borderPalette.prominent,
        selected: green[50],
      }
    : {
        backgroundColor: 'inherit',
        borderColor: borderPalette.prominent,
        selected: green[800],
      };
};
